import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'

export default class ReportingUiScopeController extends Controller {
  queryParams = ['dateRange']

  @tracked dateRange = ''
}

declare module '@ember/controller' {
  interface Registry {
    'reporting/ui-scope': ReportingUiScopeController
  }
}
